<template>
  <section class="contest-step2">
    <div class="pointBox" v-if="matchId == 1031">
      <div class="scene">{{$t('video.请选择场景')}}<span class="title1">{{$t('global.可多选')}}</span></div>
      <div class="box1">
        <span
          v-for="(item, i) in pointList"
          :key="i"
          :class="{ active: positionList.id == item.id }"
          @click="selectPoint(item.id)"
          >{{ language == 'zh' ? item.name : item.enName
          }}<i v-if="getNumber(item.id)">({{ getNumber(item.id) }})</i></span
        >
      </div>
      <div v-if="positionList && positionList.childPoint">
        <div class="scene">
          {{$t('global.请选择')}}<span class="title2">{{ language == 'zh' ? positionList.name : positionList.enName }}</span
          >{{$t('video.的点位')}}<span class="title1">{{$t('global.可多选')}}</span>
        </div>
        <div class="box2">
          <span
            v-for="(item, i) in positionList.childPoint"
            :key="i"
            :class="{ active: getActive(item.id) }"
            @click="selectPosition(item)"
            >{{ language == 'zh' ? item.name : item.enName }}</span
          >
        </div>
      </div>
      <div class="line"></div>
      <div class="scene">
        {{$t('video.已选资料包下载')}}<span class="title1"
          >{{$t('video.已选择')}} <i>{{ this.zipList.length }}</i> {{$t('video.个点位')}}</span
        >
      </div>
      <div class="box3 clearfix">
        <div
          class="zipBox"
          v-for="(item, i) in zipList"
          :key="i"
          @mouseenter="zipHover = i"
          @mouseleave="zipHover = null"
        >
          <div class="imgBox">
            <img
              class="img1"
              src="/static/match/images/icon_zip@2x.png"
              alt=""
            />
            <img
              v-if="zipHover == i"
              class="img2"
              @click="deteleZip(item.childId)"
              src="/static/match/images/x_btn@2x.png"
              alt=""
            />
          </div>
          <div class="name">{{ language == 'zh' ? item.name : item.enName }}_{{ language == 'zh' ? item.childName : item.childEnName }}</div>
        </div>
      </div>
      <div class="upload" @click="loadZip">
        <img
          src="/static/match/images/download_icon@2x.png"
          alt=""
        />{{$t('video.点击下载所有资料包')}}
      </div>
    </div>
    <div class="pointBox" v-if="matchId == 1032">
      <div class="scene" style="margin-bottom: 28px;">{{ $t("video.下载资源包") }}</div>
      <div class="upload" @click="loadZip1">
        <img
          src="/static/match/images/download_icon@2x.png"
          alt=""
        />{{$t('video.点击下载资料包')}}
      </div>
    </div>
  </section>
</template>

<script type="text/ecmascript-6">
export default {
  name: "UpVideo",
  data() {
    return {
      pointList: [],
      positionList: {},
      zipList: [],
      zipHover: null
    };
  },
  components: {},
  props: ["matchId", "matchKey"],
  computed: {
    language() {
      return this.$language();
    }
  },
  created() {
    this.getPoint();
  },
  methods: {
    getPoint() {
      this.$http.get("/api/nmatch/point").then(res => {
        this.pointList = res.data;
      });
    },
    selectPoint(id) {
      for (let i = 0; i < this.pointList.length; i++) {
        if (this.pointList[i].id == id) {
          this.positionList = this.pointList[i];
        }
      }
    },
    deteleZip(id) {
      var ids = [];
      for (let i = 0; i < this.zipList.length; i++) {
        ids.push(this.zipList[i].childId);
      }
      var index = ids.indexOf(id);
      this.zipList.splice(index, 1);
    },
    selectPosition(item) {
      if (this.zipList.length) {
        var ids = [];
        for (let i = 0; i < this.zipList.length; i++) {
          ids.push(this.zipList[i].childId);
        }
        var index = ids.indexOf(item.id);
        if (index == -1) {
          this.zipList.push({
            id: this.positionList.id,
            name: this.positionList.name,
            enName: this.positionList.enName,
            childId: item.id,
            childName: item.name,
            childEnName: item.enName,
            zipData: item.zipData
          });
        } else {
          this.zipList.splice(index, 1);
        }
      } else {
        this.zipList.push({
          id: this.positionList.id,
          name: this.positionList.name,
          enName: this.positionList.enName,
          childId: item.id,
          childName: item.name,
          childEnName: item.enName,
          zipData: item.zipData
        });
      }
    },
    getActive(id) {
      if (this.zipList.length) {
        for (let i = 0; i < this.zipList.length; i++) {
          if (this.zipList[i].childId == id) {
            return true;
          }
        }
      }
      return false;
    },
    getNumber(id) {
      var number = 0;
      if (this.zipList.length) {
        for (let i = 0; i < this.zipList.length; i++) {
          if (this.zipList[i].id == id) {
            number += 1;
          }
        }
      }
      return number;
    },
    loadZip() {
      var files = this.zipList;
      files.forEach(function(item, index) {
        setTimeout(() => {
          let a = document.createElement("a"); // 创建a标签
          let e = document.createEvent("MouseEvents"); // 创建鼠标事件对象
          e.initEvent("click", false, false); // 初始化事件对象
          a.href = "https://file.manamana.net/" + item.zipData; // 设置下载地址
          a.download = ""; // 设置下载文件名
          a.dispatchEvent(e);
        }, 1000 * index);
      });
    },
    loadZip1() {
      let a = document.createElement("a"); // 创建a标签
      let e = document.createEvent("MouseEvents"); // 创建鼠标事件对象
      e.initEvent("click", false, false); // 初始化事件对象
      a.href = "https://file.manamana.net/" + this.matchKey; // 设置下载地址
      a.download = ""; // 设置下载文件名
      a.dispatchEvent(e);
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.contest-step2 {
  .pointBox {
    width: 730px;
    margin: 0 auto;

    .scene {
      height: 27px;
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      line-height: 27px;

      .title1 {
        font-size: 13px;
        font-weight: 400;
        color: #999999;
        margin-left: 12px;

        i {
          color: #333;
          font-weight: 600;
        }
      }

      .title2 {
        font-size: 16px;
        font-weight: 600;
        color: #2026CC;
        margin: 0 4px;
      }
    }

    .box1 {
      margin: 28px 0 40px 0;

      span {
        display: inline-block;
        padding: 0 30px;
        height: 30px;
        line-height: 30px;
        background: #F5F5F5;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-right: 12px;
        margin-bottom: 12px;
        cursor: pointer;
      }

      .active {
        background: #2026CC;
        font-weight: 600;
        color: #fff;
      }
    }

    .box2 {
      margin: 28px 0 40px 0;

      span {
        display: inline-block;
        padding: 0 20px;
        height: 28px;
        line-height: 28px;
        border: 1px solid rgba(184, 184, 184, 0.85);
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-right: 12px;
        margin-bottom: 12px;
        cursor: pointer;
      }

      .active {
        border: 1px solid rgba(32, 38, 204, 0.85);
        font-weight: 600;
        color: #2026CC;
      }
    }

    .line {
      width: 730px;
      border: 1px solid #EBEBEB;
      margin-bottom: 47px;
    }

    .box3 {
      margin: 28px 0;

      .zipBox {
        float: left;
        margin-right: 16px;
        margin-bottom: 28px;
        text-align: center;
        height: 120px;
        .imgBox {
          width: 48px;
          height: 48px;
          position: relative;
          margin: 0 auto;

          .img1 {
            width: 100%;
            height: 100%;
          }

          .img2 {
            width: 24px;
            height: 24px;
            position: absolute;
            top: -12px;
            right: -12px;
            cursor: pointer;
          }
        }

        .name {
          margin-top: 12px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          width: 120px;
          word-break: break-all;
        }
      }
    }

    .upload {
      display: inline-block;
      padding: 0 16px;
      height: 36px;
      line-height: 36px;
      background: hsla(225, 84%, 57%, 0.1);
      font-size: 14px;
      font-weight: 600;
      color: #3664ED;
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
        vertical-align: text-bottom;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/match/contestEnterStep/step5.vue